import React from "react";
import "../../pages/style.css";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";

function Aboutpage() {
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <div className="aboutpagebackground">
      <Container>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >

          <Row className="textbackground">

            <Col md={7}>
              <h2 className="aboutmetext">
                About <span>Me</span>
              </h2>

              <p className="aboutdetails">
                I'm a full-stack software engineer focused on building modern
                web applications using React and JavaScript technologies.
                I also have experience in cybersecurity analysis including
                log analysis, SIEM monitoring, and incident triage.
              </p>

              <p className="aboutdetails">
                I enjoy building clean, scalable applications and solving
                complex technical problems. Outside of coding, I’m passionate
                about digital art, animation, and technology.
              </p>

              {/* Skills Section */}

              <div className="skills-section">

                <div className="skill-group">
                  <h4>Languages</h4>
                  <ul>
                    <li>Java</li>
                    <li>JavaScript</li>
                    <li>TypeScript</li>
                    <li>Python</li>
                    <li>HTML5</li>
                    <li>CSS3</li>
                  </ul>
                </div>

                <div className="skill-group">
                  <h4>Frameworks & Libraries</h4>
                  <ul>
                    <li>React</li>
                    <li>Redux</li>
                    <li>Node.js</li>
                    <li>Express.js</li>
                    <li>Angular</li>
                    <li>Spring Boot</li>
                  </ul>
                </div>

                <div className="skill-group">
                  <h4>Databases & Cloud</h4>
                  <ul>
                    <li>SQL</li>
                    <li>MySQL</li>
                    <li>PostgreSQL</li>
                    <li>MongoDB</li>
                    <li>AWS</li>
                    <li>DynamoDB</li>
                  </ul>
                </div>

                <div className="skill-group">
                  <h4>Security & Tools</h4>
                  <ul>
                    <li>Git / GitHub</li>
                    <li>REST APIs</li>
                    <li>TCP/IP</li>
                    <li>Wireshark</li>
                    <li>Nmap</li>
                    <li>Splunk</li>
                  </ul>
                </div>

              </div>

            </Col>

            <Col md={5}>
              <div className="webimage"></div>
            </Col>

          </Row>

        </motion.div>

      </Container>
    </div>
  );
}

export default Aboutpage;